import { graphql } from "react-relay";

// components
import { TeamPicker } from "@components/team-picker";
import "@components/team-join-create-dialog/TeamJoinCreateDialog.gql";

export const orgPricingGridFragments = {
  org: graphql`
    fragment OrgPricingGrid_org on Org {
      ...TeamJoinCreateDialog_org
      id
      experiments

      orgAccountingPeriod {
        __typename
        ... on OrgAccountingPeriod {
          periodRange {
            minDate
            maxDate
          }
          quotaMax
          quotaUsed
          enforcementState
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }

      billingGroups {
        ... on BillingGroupList {
          list {
            id
            name
            subscription {
              __typename
              ... on SubscriptionDetails {
                subscription {
                  productType
                }
              }
              ... on GraphEntityError {
                message
                statusCode
              }
            }
          }
        }
        ... on GraphEntityError {
          message
          statusCode
        }
      }

      featureGrid {
        __typename
        ... on FeatureGrid {
          stateMetadata {
            primaryBillingGroupMetadata {
              subscription {
                id
                type
                productType
              }
            }
            userMetadata {
              person {
                primaryCalendarId
              }
              trialMetadata {
                trialEndDate
                timeZone
              }
            }
          }
        }
        ... on GraphEntityError {
          statusCode
          message
        }
      }
    }
  `,
};
